import _ from 'lodash';
import PropTypes from 'prop-types';

const IfPlan = (props) => {
  const {
    children,
    plans,
    company,
  } = props;

  const { plan } = company;

  const render = () => {
    if (_.isFunction(children)) {
      return children();
    }
    return children;
  };

  if (_.find(plans, (element) => element === plan)) {
    return render();
  }

  return null;
};

IfPlan.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.string).isRequired,
  company: PropTypes.shape({
    plan: PropTypes.string,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]).isRequired,
};

export default IfPlan;
